import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../../../utils/cn";
import { CONTROL_CLS, SectionTitle } from "./primitives";

// Límites de gasto: frenos diarios por agente. 0 = sin límite en ambos.

export default function LimitsSection({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <section className="space-y-4">
      <SectionTitle>{t("Límites")}</SectionTitle>
      <p className="text-xs text-fg-muted">
        {t("Frenos diarios para que un agente descontrolado no se lleve el presupuesto.")}
      </p>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1">
          <label
            htmlFor="agent-max-actions"
            className="hd-field-label block text-xs font-medium text-fg"
          >
            {t("Máx. acciones por día")}
          </label>
          <input
            id="agent-max-actions"
            type="number"
            inputMode="numeric"
            min={0}
            step={1}
            value={value.max_daily_actions}
            onChange={(e) => onChange({ max_daily_actions: e.target.value })}
            className={cn(CONTROL_CLS, "sm:!w-32")}
          />
          <p className="text-[12px] md:text-[11px] text-fg-muted">
            {t("Consultas y cambios que puede hacer en un día. 0 = sin límite.")}
          </p>
        </div>

        <div className="space-y-1">
          <label
            htmlFor="agent-max-tokens"
            className="hd-field-label block text-xs font-medium text-fg"
          >
            {t("Máx. tokens por día")}
          </label>
          <input
            id="agent-max-tokens"
            type="number"
            inputMode="numeric"
            min={0}
            step={1}
            value={value.max_daily_tokens}
            onChange={(e) => onChange({ max_daily_tokens: e.target.value })}
            className={cn(CONTROL_CLS, "sm:!w-32")}
          />
          <p className="text-[12px] md:text-[11px] text-fg-muted">
            {t("Tope de consumo diario del proveedor. 0 = sin límite.")}
          </p>
        </div>
      </div>
    </section>
  );
}
